import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import api from '../utils/api';
import './TermsOfService.css';

const TermsOfService = () => {
  const [terms, setTerms] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchTermsOfService();
  }, []);

  const fetchTermsOfService = async () => {
    try {
      const response = await api.get('/policies/terms');
      // API returns { success: true, data: {...}, message: '...' }
      // axios wraps it, so response.data = { success: true, data: {...}, message: '...' }
      const termsData = response.data?.data || null;
      setTerms(termsData);
    } catch (error) {
      console.error('Error fetching terms of service:', error);
      setTerms(null);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="terms-of-service page-transition">
      <section className="terms-hero">
        <div className="container">
          <motion.div
            className="terms-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="terms-hero-title">Terms of Service</h1>
            {terms && (
              <p className="terms-version">Version {terms.version}</p>
            )}
          </motion.div>
        </div>
      </section>

      <section className="terms-content">
        <div className="container">
          {isLoading ? (
            <div className="terms-loading">Loading...</div>
          ) : terms ? (
            <motion.div
              className="terms-body"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h2 className="terms-title">{terms.title}</h2>
              <div
                className="terms-text"
                dangerouslySetInnerHTML={{ __html: terms.content }}
              />
              {terms.created_at && (
                <p className="terms-date">
                  Last updated: {new Date(terms.updated_at || terms.created_at).toLocaleDateString()}
                </p>
              )}
            </motion.div>
          ) : (
            <div className="terms-empty">
              <p>Terms of Service not available yet.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;

